import UrlHelpers from "./url";
import {dvLogo, landingPageBackground} from "./icons";

export class SubscriptionWizardV2LandingPage {

    constructor() {

        (<HTMLButtonElement>document.getElementById('subscriptionWizardV2LandingPage_startWizard')).addEventListener('click', (e: Event) => {
            window.top.location.href = (<HTMLElement>e.target).dataset['target'];
        });

        this.setBackgroundImage();
        this.googlePageView();

        window.addEventListener('load', () => {
            this.showLandingPageContent();
        })
    }

    private showLandingPageContent = () => {
        const content = <HTMLElement>document.getElementById('subscriptionWizardV2LandingPage');
        if (!content) {
            console.log('cannot find element \'content\'');
            return;
        }
        content.style.display = '';
    };

    private setBackgroundImage = (): void => {
        const setBgImage = (e: HTMLDivElement, url: string) => {
            e.style.backgroundImage = `url('${url}')`;
        };
        const branding = <HTMLDivElement>document.querySelector('.dv-branding');
        setBgImage(branding, dvLogo);
        const landingPage = <HTMLDivElement>document.querySelector('.landing-page-bg-image');
        if (landingPage) {
            setBgImage(landingPage, landingPageBackground)
        }
        const landingPagePlaceholder = <HTMLImageElement>document.getElementById('landing-page-bg-image-placeholder');
        if (landingPagePlaceholder) {
            landingPagePlaceholder.src = landingPageBackground;
        }
    };

    private googlePageView = () => {
        if (!UrlHelpers.getMetaData("gtmActive") || UrlHelpers.getMetaData('sysAdmin')) {
            return;
        }
        const gtmValues = {pagePath: '/center/subscription/landingPage', pageTitle: 'Landing Page'};
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        window.dataLayer.push({
            'event': 'Pageview',
            'pagePath': gtmValues.pagePath,
            'pageTitle': gtmValues.pageTitle
        });
    };
}